import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.406 10c.618 1.104 1.493 2.13 2.485 2.877 1.003.754 2.082 1.19 3.109 1.19 1.027 0 2.106-.436 3.109-1.19.992-.746 1.867-1.773 2.485-2.877-.618-1.104-1.492-2.13-2.485-2.877-1.003-.754-2.082-1.19-3.109-1.19-1.027 0-2.106.436-3.109 1.19-.993.746-1.867 1.773-2.485 2.877ZM6.05 6.004C7.213 5.129 8.58 4.532 10 4.532c1.42 0 2.787.597 3.95 1.472 1.167.877 2.173 2.067 2.88 3.338.227.41.227.907 0 1.316-.707 1.272-1.713 2.46-2.88 3.338-1.163.875-2.53 1.471-3.95 1.471-1.42 0-2.787-.596-3.95-1.47-1.167-.878-2.173-2.068-2.88-3.339a1.356 1.356 0 0 1 0-1.316c.707-1.272 1.713-2.46 2.88-3.338Zm4.947 3.053a1.442 1.442 0 0 0-1.994 0 1.304 1.304 0 0 0 0 1.886 1.442 1.442 0 0 0 1.994 0 1.304 1.304 0 0 0 0-1.886Zm-2.97-1.004a2.842 2.842 0 0 1 3.946 0 2.704 2.704 0 0 1 0 3.893 2.842 2.842 0 0 1-3.946 0 2.704 2.704 0 0 1 0-3.893Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
